/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 15:25:00
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 10:00:02
 * @name: 注册
 * @Description: 注册
 * @FilePath: \project\src\module\user\validator\register.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'real_name',
    description: '姓名',
    required: true,
    required_message: '姓名为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入姓名';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'mobile',
    description: '手机号',
    required: true,
    required_message: '手机号为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入手机号';
      } else if (!(e.length === 11 && /^\d+$/.test(e))) {
        return '手机号格式错误';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'password',
    description: '密码',
    required: true,
    required_message: '密码为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入密码';
      } else if (!/\w{6,}/.test(e)) {
        console.log(111);
        return '密码不少于6位';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'verify_code',
    description: '验证码',
    required: true,
    required_message: '验证码为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入验证码';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
]